import styled from 'styled-components';
import Link from '@magalu/stereo-ui/atoms/Link';
export const MediaReviewCardComponent = styled(Link).attrs(props => Object.assign({}, props))`
  width: ${props => props.width || '90px'};
  height: ${props => props.height || '90px'};
  background: url(${props => props.mediaUrl}) no-repeat center lightgray;
  background-size: cover;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
`;